// parse string with format 'yyyy-MM-dd' to date object
// We can't use new Date(dateString) because it might create a wrong date depending on the user timezone
export const parseStringToDate = (dateString: string) => {
  const splitDate = dateString.split('-');
  if (splitDate.length !== 3) {
    return undefined;
  }

  const date = new Date();
  date.setMilliseconds(0);
  date.setHours(0, 0, 0);
  date.setMonth(+splitDate[1] - 1, +splitDate[2]);
  date.setFullYear(+splitDate[0]);

  return date;
};

export const formatDateStringToYearMonth = (dateString: string) => {
  const splitDate = dateString.split('-');
  if (splitDate.length < 2) {
    return undefined;
  }
  const year = splitDate[0].slice(-2);
  const monthName = monthsShortNames[+splitDate[1] - 1];
  return monthName + ' ' + year;
};

const monthsShortNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
